export const BRAND = {
  name: 'PipMaster',
  displayDomain: 'PipMaster.ai',
  domain: 'https://pipmaster.ai',
  statusUrl: 'https://status.pipmaster.ai',
  supportEmail: 'support@pipmaster.ai',
  legalEmail: 'legal@pipmaster.ai',
  privacyEmail: 'privacy@pipmaster.ai',
  githubReleases: 'https://github.com/tfiliano/chartmind/releases',
  storagePrefix: 'pipmaster',
} as const;
